import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { TMenuCategory, TRestaurant } from '../types';

const initialState: {
    menuItems?: TMenuCategory[],
    info?: TRestaurant
} = {
};

const restaurantSlice = createSlice({
    name: 'menuItems',
    initialState,
    reducers: {
        setMenuItems: (state, action: PayloadAction<TMenuCategory[]>) => {
            state.menuItems = action.payload
        },
        setRestaurantInfo: (state, action: PayloadAction<TRestaurant>) =>{
            state.info = action.payload
        }
    }
})

export default restaurantSlice;